import { render } from "./tag-materials.vue?vue&type=template&id=567ab810&ts=true"
import script from "./tag-materials.vue?vue&type=script&lang=ts"
export * from "./tag-materials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__